'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { FillScreen, VStack } from '@/components/Layout';
import RootHeader from '@/components/Layout/RootHeader';
import { featureFlags } from '@/lib/env';
export const Route = createFileRoute('/_cockpit-mock')({
  component: CockpitMockLayout
});
function CockpitMockLayout() {
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <FillScreen className="bg-neutral-bottom-fill">
      <VStack className="h-full">
        <RootHeader />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </VStack>
    </FillScreen>;
}